import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { evaluationBulkCreationPost } from "#performance-evaluation/services/api"
import { Stack, Typography } from "@mui/material"
import { useReloadRefresh } from "app/reload"
import { useState } from "react"

export default function MyTeamBulkCreation({ open, setOpen }) {
	const { refresh } = useReloadRefresh()

	const [disabled, setDisabled] = useState(false)

	const success = () => {
		setOpen(false)
		refresh()
	}

	const end = () => {
		setDisabled(false)
	}

	const { fetch } = useApiSend(evaluationBulkCreationPost, { success, end })

	const handleSubmit = () => {
		setDisabled(true)
		fetch()
	}

	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				handleSubmit,
				title: "Crear evaluaciones ",
				maxWidth: "sm",
				disabled,
			}}
		>
			<Stack spacing={1}>
				<Typography variant="body1" fontWeight={600}>
					¿Deseas crear evaluaciones para todos los colaboradores activos?
				</Typography>
				{/* <Typography variant="body2" color="text.secondary">
					Al confirmar, se crearán evaluaciones para todos los colaboradores activos.
				</Typography> */}
			</Stack>
		</DialogMaster>
	)
}
